import { ValueUnit } from "../store/modules/collaboration/index";

interface FolderListItem {
  type: "folderListItem";
  itemValueUnit: ValueUnit;
}

const formatEvent = ([key, value]): FolderListItem => {
  return {
    type: "folderListItem",
    itemValueUnit: value
  };
};

const mapEventsToListItems = (events): FolderListItem[] =>
  Object.entries(events).map(formatEvent);

export default mapEventsToListItems;
